import * as React from 'react';

import { IQueryFilterCriteria } from '../../interfaces/IQuery';

export interface IRangeControlProps {
    disableFrom: boolean;
    disableTo: boolean;
    fromName: string;
    fromValue: string | number;
    isCurrency: boolean;
    item: IQueryFilterCriteria;
    toName: string;
    toValue: string | number;
    onFromChange: (e: React.ChangeEvent<HTMLInputElement>, item: IQueryFilterCriteria) => void;
    onToChange: (e: React.ChangeEvent<HTMLInputElement>, item: IQueryFilterCriteria) => void;
    allowDecimal?: boolean; // new optional prop
}

export function NumericRangeControl({
    disableFrom,
    disableTo,
    fromName,
    fromValue,
    toName,
    toValue,
    isCurrency,
    item,
    onFromChange,
    onToChange,
    allowDecimal = false,
}: IRangeControlProps) {
    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement>,
        item: IQueryFilterCriteria,
        onChange: (e: React.ChangeEvent<HTMLInputElement>, item: IQueryFilterCriteria) => void
    ) => {
        const inputValue = e.target.value;
        //accepts only decimal ( negative sign, one decimal point)//-123, 123.56
        const regex = allowDecimal ?  /^-?\d*\.?\d*$/
            : /^-?\d*$/; //allows only whole number no decimal point.

        if (regex.test(inputValue) || inputValue === '') {
            onChange(e, item);
        }
    };

    return (
        <div style={{ display: 'block' }}>
            {isCurrency && <span>$&nbsp;</span>}
            <input
                className="form-control d-inline-block"
                type="text"
                name={fromName}
                disabled={disableFrom}
                onChange={(e) => handleChange(e, item, onFromChange)}
                value={fromValue}
            />
            <span style={{ display: 'inline-block', margin: '0 8px' }}>to</span>
            <input
                className="form-control d-inline-block"
                type="text"
                name={toName}
                disabled={disableTo}
                onChange={(e) => handleChange(e, item, onToChange)}
                value={toValue}
            />
            <span className="text-danger ms-2">{item.validationError}</span>
        </div>
    );
}
